const listeners = new Set();

export const confettiEmitter = {
  emit: () => {
    listeners.forEach((fn) => fn());
  },
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export const triggerConfetti = () => {
  confettiEmitter.emit();
};
